import React, { useEffect, useRef } from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import onboarding_goal_earth from "static/image/onboarding/goal_earth_80000.png";
import useIsInappWebview from "hooks/useIsInappWebview";
import { BottomNextButtonTmp } from "../../../../components/common/BottomNextButtonTmp";

export default function Goal_4_Promotion() {
  const navigate = useNavigate();
  const isInappWebview = useIsInappWebview();

  const handleNext = () => {
    navigate(`/promotion-onboarding/goal/5`);
  };

  const pageKey = "goal_4";

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {});

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Stack
        spacing={2}
        sx={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <CustomTypography
          variant="Subtitle"
          fontWeight={700}
          sx={{
            color: theme.vars.palette.Content.Highlight,
          }}
        >
          나는 혼자가 아니에요.
        </CustomTypography>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          디스턴싱은 80,000명 이상의 사람들과 함께하며 그들의 삶을
          변화시켰습니다.
        </CustomTypography>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={onboarding_goal_earth}
            alt={"onboarding"}
            style={{
              maxWidth: "308px",
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
      </Stack>
      <BottomNextButtonTmp
        disabled={false}
        onClick={handleNext}
        text={"다음"}
        highlightBackground={true}
      />
    </Box>
  );
}
